import React from 'react'
import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";
import "moment/locale/es";
import './styleCalender.css';
import { Col, Row, Input } from 'reactstrap';


export const EventAmount = (props) => {

    const { start, end, setEnd, setStart, handleInputChange, title, loadingViews } = props;


    return (
        <div className='pt-3' >
            <div
                style={{
                    color: "#856404",
                    fontSize: "0.78rem",
                    marginTop: "6px",
                    fontWeight: "500",
                    backgroundColor: "#fff3cd",
                    padding: "4px 10px",
                    borderRadius: "6px",
                    boxShadow: "0 1px 2px rgba(0,0,0,0.08)",
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    border: "1px solid #ffeeba",
                }}

            >
                <i className="fa fa-exclamation-triangle" style={{ color: "#d39e00" }}></i>
                Para programar un evento mensual es necesario generar el titulo del evento junto al periodo que aplicara.
            </div>
            <Col sm="12" className='pt-5 p-l-0 p-r-0' >
                <Row>

                    <Col sm="4">
                        <label className='f-12 f-w-600' style={{ color: "#002940", fontSize: "13px" }}>Titulo *</label>
                        <Input type='text' name="title" value={title} onChange={handleInputChange} className={loadingViews === true ? "border-0 mr-2" : `form-control form-control-sm input-air-primary border-primary b-r-9 f-14`} />
                    </Col>
                    <Col sm="4">
                        <label className='f-12 f-w-600' style={{ color: "#002940", fontSize: "13px" }}>Inicia-Termina *</label>
                        <DateRangePicker
                            initialSettings={{
                                locale: {
                                    format: "YYYY-MM-DD",
                                    applyLabel: "Aplicar",
                                    cancelLabel: "Cancelar"
                                },
                                startDate: start,
                                endDate: end,
                                timePicker: false,
                                drops: 'up'
                            }}
                            onApply={(event, picker) => {
                                setStart(new Date(picker.startDate));
                                setEnd(new Date(picker.endDate));
                            }}
                        >
                            <input className={`form-control form-control-sm input-air-primary border-primary`} type="text" />
                        </DateRangePicker>
                    </Col>
                </Row>
            </Col>

        </div>
    )

}
